module.exports = __webpack_public_path__ + "static/media/Mazhar Fareed Resume.01482677.jpg";